import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import { InactiveUserStore, InactiveUser } from './types'

export const useInactiveUserStore = create<InactiveUserStore>()(
  persist(
    (set, get) => {
      return {
        inactiveUser: null,
        setInactiveUser: (user: InactiveUser) => {
          set({
            inactiveUser: {
              ...get().inactiveUser,
              ...user,
            },
          })
        },
        userActivated: false,
        setUserActivated: activated => {
          set({ userActivated: activated })
        },
        confirmedData: false,
        setConfirmedData: confirmed => {
          set({ confirmedData: confirmed })
        },
      }
    },
    {
      name: 'inactiveUser',
      getStorage: () => sessionStorage,
    },
  ),
)
